import i18n from '../../i18n';

/**
 * 渲染首页与营销中带「建议图片尺寸」提示的卡头标题：`titleKey` 的文案内需含 `{{hint}}`。
 * `hint` 使用独立 key `first_screen_text_suggested_image_size`，便于统一维护尺寸说明。
 * @param titleKey - 标题 i18n key（如 `first_screen_setting_page_restaurant_activity_notice`）
 * @returns 展开 hint 后的完整标题
 */
export function tFirstScreenCardTitleWithSuggestedImageSize(titleKey: string): string {
    /** 建议尺寸片段，与各语言 `first_screen_text_suggested_image_size` 对应 */
    const hint = i18n.t('first_screen_text_suggested_image_size');
    return i18n.t(titleKey, { hint });
}
